import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  deleteProductMarca,
  getProductMarcas,
} from "../../../../api/productMarca";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductMarcaContent from "./ProductMarcaContent";

function getData(productMarcas) {
  let data = [];
  for (let i = 0; i < productMarcas.length; ++i) {
    const elem = {};
    const productMarca = productMarcas[i];

    elem.nombre = productMarca?.nombre;
    elem.id = productMarca?.id;

    data = data.concat(elem);
  }
  return data;
}

export default function ProductMarcaPage() {
  const [data, setData] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState(null);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openMarcaInfoDialog, setOpenMarcaInfoDialog] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const history = useHistory();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              history.push("/marcas-productos/" + cell + "/edit");
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
          <>
            <Tooltip title="Eliminar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMarca(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Marcas de productos">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/marcas-productos/edit")}
            >
              Nueva marca
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={getData(data)}
            columns={columns}
            rowEvents={{
              onClick: (e, row, rowIndex) => {
                const marca = data?.find((x) => x.id === row.id);
                setSelectedMarca(marca);
                setOpenMarcaInfoDialog(true);
              },
            }}
          />
          <ConfirmDialog
            title={
              "¿Estás seguro de que quieres eliminar esta marca de producto?"
            }
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProductMarca(selectedMarca?.id, loggedUser?.accessToken)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminado!",
                      customMessage: "Marca eliminada con éxito.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la marca.",
                  });
                });
            }}
          />
          <EntityInfoDialog
            title={"Marca: " + selectedMarca?.nombre}
            open={openMarcaInfoDialog}
            setOpen={setOpenMarcaInfoDialog}
            content={<ProductMarcaContent marca={selectedMarca} />}
          />
        </CardBody>
      </Card>
    </>
  );
}
